export default function NewsPage() {

    return <div className="page-content latest-news">
        <div className="news-item">
            <h2>Windowsoppdatering 8.8.2023</h2>
            <p>En windowsoppdatering fra tirsdag 8.8.2023 fører til at PCKasse-programmet lastes ned på nytt.<br/>
                Det går i de fleste tilfellene bra, men en sjelden gang tør ikke kunde å trykke "Ok" på spørsmålet
                om å laste ned og
                innstallere PCKasse.</p>

            <p>I tillegg har vi får noen tilfeller der instillingene i PCKasse har blitt borte.<br/>
                Da må man laste inn de på nytt.<br/>
                (De ligger i "Mine dokumenter")</p>
        </div>

        <div className="news-item">
            <h2>ERP POS - VERSJONER AV VB OG GLOBAL</h2>
            <ul>
                <li>ERP POS versjon 16.00 virker med Visma Business versjon 16.10 til 18.10.</li>
                <li>ERP POS versjon 16.00 virker med Global versjon 16.xx til 18.10.</li>
            </ul>
        </div>
    </div>
}
